import { Text, View } from '@components/primitives';
import { AntDesign } from '@expo/vector-icons';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles';

const ReferralDoneButton: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <View style={styles.buttonDone}>
      <Text testID="txtReferralValid" variant="md-bold" color={colors.variants.clover}>
        {t('referral.validReferral')}
      </Text>
      <AntDesign name="check" size={scale(24)} color={colors.variants.clover} style={styles.checkIconStyles} />
    </View>
  );
};

export default ReferralDoneButton;
